import { render, staticRenderFns } from "./data-inspection.vue?vue&type=template&id=22bd0476&scoped=true&"
import script from "./data-inspection.vue?vue&type=script&lang=js&"
export * from "./data-inspection.vue?vue&type=script&lang=js&"
import style0 from "./data-inspection.vue?vue&type=style&index=0&id=22bd0476&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bd0476",
  null
  
)

export default component.exports